import styled from 'styled-components/macro';

import EntityItem from 'components/base/EntityItem/EntityItem';
import {
  EntityTitle,
  ArtworkWrapper,
} from 'components/base/EntityItem/EntityItem.style';
import EntityItemLoader from 'components/utility/ContentLoader/EntityItemLoader/EntityItemLoader';
import { SearchFieldContainer } from 'components/styled/SearchField/SearchField';

import modularScale from 'styles/helpers/modular-scale';
import { definitionLabel } from 'styles/base-classes';
import { WhiteBlock } from 'components/utility/GenericComponent/GenericComponent';

export const Label = styled('h3')`
  ${definitionLabel};
  margin-bottom: 0;
`;

export const VersionsLabel = styled.h3`
  ${definitionLabel};
  padding: ${({ theme }): string => theme.spacing.xsmall};
  margin: 0;
  margin-top: ${({ theme }): string => theme.spacing.medium};
`;

export const ParentEntityItem = styled(EntityItem)`
  padding: ${({ theme }): string => theme.spacing.xsmall} 0;
  margin-bottom: ${({ theme }): string => theme.spacing.small};

  ${EntityTitle}, ${ArtworkWrapper} {
    font-size: ${modularScale(1)};
  }
`;

export const ParentEntityItemLoader = styled(EntityItemLoader)`
  font-size: ${modularScale(1)};
  margin: ${({ theme }): string => theme.spacing.xsmall} 0;
`;

export const ParentEntityItemLink = styled(ParentEntityItem)`
  ${EntityTitle} {
    transition: ${({ theme }): string =>
      `border-bottom ${theme.transitionDuration} ${theme.timingFunction}`};
    border-bottom: 1px solid transparent;
  }

  &:hover,
  &:focus {
    background: none;

    ${EntityTitle} {
      border-bottom: 1px solid;
    }
  }

  &:active {
    background: ${({ theme }): string => theme.LightGrey};
  }
`;

export const BrowseLayoutContainer = styled.div`
  margin: ${({ theme }): string => `0 0 ${theme.spacing.large}`};
`;

export const SearchFieldBlock = styled('div')`
  margin: 0;
  @media screen and (min-width: 40em) {
    max-width: 230px;
  }

  ${SearchFieldContainer} {
    margin-bottom: 3px;
    @media screen and (min-width: 40em) {
      margin-bottom: 0.75em;
    }
  }
`;

export const TopEntityContent = styled('section')`
  @media screen and (max-width: 47em) {
    margin: ${({ theme }): string => `0 ${theme.spacing.small}`};
  }
  @media screen and (min-width: 50em) and (max-width: 80em) {
    width: 90%;
    margin: auto;
  }
  @media screen and (min-width: 80em) {
    width: 75%;
    margin: 0 auto;
  }
  margin: 0 1em;

  ${WhiteBlock} {
    @media screen and (min-width: 60em) {
      width: 100%;
    }
  }
`;

export const ActualDate = styled.p`
  color: ${({ theme }): string => theme.NightBlue};
  font-size: 19px;
  font-weight: 600;

  @media screen and (max-width: 50em) {
    margin: ${({ theme }): string => theme.spacing.medium} 0;
  }
`;
